import axios from 'axios'
import { sign } from './signHeaders'
import qs, { stringify } from 'qs'
import { headersLanguageKey } from '../utils/index'
import { URL_DOMAIN, TEXT_PREFIX } from '../../config.json'

function isSignedApi(url) {
  const signedApis = ['/chat-web/data/invokeOtherByUser.action']
  const { pathname } = new URL(url, window.location.origin)
  return signedApis.includes(pathname)
}

axios.interceptors.request.use(
  (config) => {
    const language = window[headersLanguageKey]

    let url = config.url?.replace(URL_DOMAIN + TEXT_PREFIX, '')

    if (isSignedApi(url)) {
      let signUrl = url
      const hasQuery = signUrl?.includes('?')
      const timestamp = Date.now()

      if (config.method === 'post') {
        let data = config.data || {}
        data.timestamp = timestamp
        signUrl = `${signUrl}${hasQuery ? '&' : '?'}${stringify(data)}`
        data.visitorSign = sign(signUrl)
        config.data = data
      } else {
        signUrl = `${signUrl}${hasQuery ? '&' : '?'}timestamp=${timestamp}`
        url = `${signUrl}&visitorSign=${sign(signUrl)}`
      }
    }
    config.headers['language'] = language
    config.headers['Bno'] = window.urlObject?.sysNum

    // Object.assign(config.headers, _header)
    if (config.method === 'post' && !config.headers?.['Content-Type']) {
      config.data = qs.stringify(config.data)
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    config.url = `${URL_DOMAIN}${TEXT_PREFIX}${url}`
    return config
  },
  (err) => {
    return Promise.resolve(err)
  }
)

axios.interceptors.response.use(
  (data) => {
    return data.data
  },
  (err) => {
    const {
      response: { status }
    } = err
    if (status >= 500) {
    } else if (status === 404) {
    }
    return Promise.resolve(err.response)
  }
)
